export default __webpack_public_path__ + "static/media/send.c8448dc4.svg";